<template>
  <div class="data-form">
    <template v-for="(row, index) of layoutSetting.sectionFields">
      <v-divider :key="tool.getRandomKey(index)" v-if="row.divider" class="m-v-10"></v-divider>
      <v-layout row :key="tool.getRandomKey(index)">
        <v-flex lg3>
          <label class="field-name">{{ row.paid.label }}</label>
        </v-flex>
        <v-flex lg2>
          <label class="field-value currency">{{ tool.formatCurrencyWithFieldKey(paymentFeeData.paid, row.paid.fieldKey) }}</label>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex lg3>
          <label class="field-name">{{ row.left.label }}</label>
        </v-flex>
        <v-flex lg2>
          <label class="field-value currency">{{ tool.formatCurrencyWithFieldKey(paymentFeeData.left, row.left.fieldKey) }}</label>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>

import { ProcessingApi } from '@/api/pandaria'
import { DataType, Tool } from '@/util/index'

const tool = new Tool()
export default {
  name: 'loan-detail-payment-progress',
  props: {
    loan: Object,
    layoutSetting: Object,
    installmentData: {
      type: Object,
      default: () => {}
    },
    slaveLoanId: Number
  },
  data () {
    return {
      paymentFeeData: {
        paid: {
          principal: 0,
          interest: 0,
          unpaidFee: 0,
          amount: 0
        },
        left: {
          principal: 0,
          interest: 0,
          unpaidFee: 0,
          amount: 0
        }
      },
      tool: new Tool()
    }
  },
  watch: {
    slaveLoanId (newVal) {
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        this.getPaymentFee(newVal)
      }
    },
    loan (val) {
      if (val.loanType !== DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        this.getPaymentFee(val.id)
      }
    },
    installmentData (val) {
      if (this.tool.isNotEmpty(val)) {
        this.paymentFeeData.paid = {
          principal: 0,
          interest: 0,
          unpaidFee: 0,
          amount: 0
        }
        this.paymentFeeData.left = {
          principal: val.totalPrincipal,
          interest: val.totalInterest,
          unpaidFee: val.totalUnpaidFee,
          amount: val.totalAmount
        }
      } else {
        this.paymentFeeData.paid = {
          principal: 0,
          interest: 0,
          unpaidFee: 0,
          amount: 0
        }
        this.paymentFeeData.left = {
          principal: 0,
          interest: 0,
          unpaidFee: 0,
          amount: 0
        }
      }
    }
  },
  mounted () {
    this.$eventBus.$on('get-clicked-slave-detail-event', target => {
      this.getPaymentFee(target.loanId)
    })
  },
  methods: {
    getPaymentFee (loanId) {
      if (tool.isEmpty(loanId)) {
        return
      }
      const $this = this
      const paymentFeeRequest = {
        loanId: loanId,
        typeList: [
          DataType.PaymentFeeTypeEnum.PAID_IN_PROCESS.value,
          DataType.PaymentFeeTypeEnum.LEFT_IN_PROCESS.value
        ]
      }
      ProcessingApi.getPaymentFeeData(paymentFeeRequest, function (result) {
        if ($this.tool.isNotEmpty(result)) {
          $this.paymentFeeData.paid = result[DataType.PaymentFeeTypeEnum.PAID_IN_PROCESS.value]
          $this.paymentFeeData.left = result[DataType.PaymentFeeTypeEnum.LEFT_IN_PROCESS.value]
        }
      })
    }
  }
}
</script>

<style scoped>
.data-form {
  font-size: 14px;
  padding: 20px 0;
}

.data-form .row {
  margin: auto !important;
}

.data-form .flex {
  padding: 0 !important;
}

.data-form label {
  font-weight: unset;
  margin-bottom: unset;
}

.data-form .field-name {
  color: #222222;
  font-weight: 400;
}

.data-form .field-value {
  color: #002B7F;
  white-space: nowrap;
}
</style>
